import '../../_rollupPluginBabelHelpers-a38db067.js';
import '../utils.js';
import './core-utils.js';
import { createParser } from './parser.js';
import { createStyleFunction } from './style-function.js';

function system(args = {}) {
  const config = {};
  Object.keys(args).forEach(key => {
    const argConfig = args[key];
    if (argConfig === false) {
      return;
    }
    if (argConfig === true) {
      config[key] = createStyleFunction({
        property: key
      });
      return;
    }
    if (typeof argConfig === 'function') {
      config[key] = argConfig;
      return;
    }
    config[key] = createStyleFunction(argConfig);
  });
  return createParser(config);
}

export { system };
